export default __webpack_public_path__ + "static/media/nn-basic.c16dd1e2.jpeg";